/**
 * @file topbar
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.less';

export default class TopBar extends Component {
    static propTypes = {
        typeLeft: PropTypes.bool
    };

    state = {
        isMenuShow: false
    };

    changeMenuStatus(isShow) {
        this.setState({isMenuShow: isShow});
    }

    renderMenu() {
        return [
            <ul key="menu" className="menu">
                <li>
                    <a href="/m/forum">
                        <span className="menu-icon forum"></span>
                        安全社区首页
                    </a>
                </li>
                <li>
                    <a href="/m/productCenter">
                        <span className="menu-icon product-center-icon"></span>
                        产品板块
                    </a>
                </li>
                <li>
                    <a href="/m/submission">
                        <span className="menu-icon submission"></span>
                        投稿
                    </a>
                </li>
                <li>
                    <a href="/m/">
                        <span className="menu-icon home"></span>
                        返回百度安全官网
                    </a>
                </li>
            </ul>,
            <div onClick={this.changeMenuStatus.bind(this, false)} key="mask" className="mask"></div>];
    }

    render() {
        const className = classnames('top-bar pr', {active: this.state.isMenuShow});

        return (
            <div className={className}>
                <div className="top-bar-left">
                    <a href="/m/forum" className="spu-logo">
                        <img src={require('../../asset/svg/image_forum_home.svg')} alt="spu-logo"/>
                    </a>
                </div>

                <div className="top-bar-right">
                    <a href={'/m/forum/search'} className={'search-link'}>
                    </a>
                    <span className="menu-btn">
                        {this.state.isMenuShow
                            ? <img
                                onClick={this.changeMenuStatus.bind(this, false)}
                                src={require('../../asset/svg/icon_menu_close.svg')}
                                alt="forum-menu"/>
                            : <img
                                onClick={this.changeMenuStatus.bind(this, true)}
                                src={require('../../asset/svg/icon_menu.svg')}
                                alt="forum-menu"/>}
                    </span>
                </div>
                {this.state.isMenuShow && this.renderMenu()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/index.js